import { COMBAT_DISTANCE_MELEE, COMBAT_DISTANCE_RANGED }  from './constants.js'

export class Archetype {

    static meleeDps(isAdversary = true) {
        const combatDistance = COMBAT_DISTANCE_MELEE
        let cssImageVariable
        if(isAdversary) {
            cssImageVariable = 'sprite-claw'
        } else {
            cssImageVariable = 'sprite-fighter'
        }
        return {
            combatDistance,
            cssImageVariable,
            label: 'Melee DPS',
        }
    }

    static rangedDps(isAdversary = true) {
        const combatDistance = COMBAT_DISTANCE_RANGED
        let cssImageVariable
        if(isAdversary) {
            cssImageVariable = 'sprite-spit'
        } else {
            cssImageVariable = 'sprite-archer'
        }
        return {
            combatDistance,
            cssImageVariable,
            label: 'Ranged DPS',
        }
    }
}